const USER_STATE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export default (user) => user.state === USER_STATE.ACTIVE;
